import axios from "axios";

// export async function addCandidate(candidate) {
//   return axios
//     .post("/candidate", candidate, { headers: { "Content-Type": "multipart/form-data" } })
//     .then((response) => response.data)
//     .catch((err) => {
//       if (err.response.status === 409) {
//         throw Error(err.response.data.message);
//       }
//       throw Error(err);
//     });
// }

export async function addCandidate(candidate) {
  try {
    const response = await axios.post("/candidate", candidate, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response.data;
  } catch (err) {
    if (err.response?.status === 409) {
      throw new Error(err.response.data.message || "Candidate already exists");
    }
    throw new Error(`Failed to add candidate: ${err.message}`);
  }
}

export async function isCandidateExists(email) {
  const res = await axios.get("/candidate/isExists", { params: { email } });
  return res.data;
}

export async function getCandidates(
  sort,
  column,
  limit,
  offset,
  searchQuery,
  exp,
  location,
  skills,
  startDate,
  endDate,
  status,
  id
) {
  const queryParams = {
    limit: limit,
    offset: offset,
    searchQuery: searchQuery || "",
    orderBy: column,
    orderByValue: sort,
    yoe: exp,
    location,
    skills,
    startDate,
    endDate,
    status,
    id: id
  };
  const response = await axios.get("/candidate", { params: queryParams });
  return response.data;
}

export async function getDeletedCandidates(sort, column, limit, offset, searchQuery, id) {
  const queryParams = {
    limit: limit,
    offset: offset,
    searchQuery: searchQuery || "",
    orderBy: column,
    orderByValue: sort,
    id: id
  };
  const response = await axios.get("/candidate/deleted", { params: queryParams });
  return response.data;
}

export async function getCandidate(id) {
  try {
    const queryParams = { id };
    const response = await axios.get("/candidate", { params: queryParams });
    if (!response.data) {
      throw new Error("No candidate data found");
    }
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch candidate: ${error.message}`);
  }
}

export async function deleteCandidate(id) {
  return axios.patch("/candidate/" + id, { jp_is_deleted: true }).catch((err) => {
    throw Error(err);
  });
}

export async function restoreCandidate(id) {
  return axios.patch("/candidate/" + id, { jp_is_deleted: false }).catch((err) => {
    throw Error(err);
  });
}

// export async function updateCandidate(candidate, id) {
//   const response = await axios.put("/candidate/" + id, candidate, {
//     headers: { "Content-Type": "multipart/form-data" }
//   });
//   return response.data;
// }

export async function updateCandidate(candidate, id) {
  try {
    const response = await axios.put(`/candidate/${id}`, candidate, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response.data;
  } catch (err) {
    throw new Error(`Failed to update candidate: ${err.message}`);
  }
}
export async function updateCandidateEmailStatus(id, status, email) {
  const res = await axios.patch("/candidate/update-email-status/" + id, { status, email });
  return res.data;
}

export async function getCandidateResume(id, filename) {
  try {
    const response = await axios.get("/candidate/resume", {
      params: { id: id },
      responseType: "blob"
    });
    if (response.data) {
      return response.data;
    } else {
      return [];
    }
  } catch (e) {
    console.log(e);
  }
}

// export async function updateCandidatePassword(id, newPass, oldPass, reset = false) {
//   const response = await axios.patch(
//     "/candidate/change-password",
//     {
//       id,
//       newPass,
//       oldPass,
//       reset
//     },
//     { "Content-Type": "application/json" }
//   );
//   return response.data;
// }

export async function updateCandidatePassword(id, newPass, oldPass, reset = false) {
  try {
    const response = await axios.patch("/candidate/change-password", {
      id,
      newPass,
      oldPass,
      reset
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("Unauthorized: Please login again");
    }
    throw error;
  }
}

export async function getCandidateId(email) {
  try {
    const response = await axios.get("/candidate/get-id-by-email", { params: { email } });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function resetCandidatePassword({ id, newPass }) {
  const resetToken = localStorage.getItem("resetToken");
  const headers = {
    "Content-Type": "application/json"
  };

  if (resetToken) {
    headers.Authorization = `Bearer ${resetToken}`;
  }

  const response = await axios.patch(
    "/candidate/reset-password",
    {
      id,
      newPass,
      reset: true
    },
    { headers }
  );
  return response.data;
}

export async function updateCandidateStatus(candidateId, status, updatedBy) {
  const response = await axios.patch(`/candidate/${candidateId}/status`, {
    jp_is_active: status,
    jp_updated_by: updatedBy
  });
  return response.data;
}

export async function bulkInsertCandidates(file) {
  const response = await axios.post("/candidate/bulk", file, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
}

export async function extractCandidateInfoFromResume(file) {
  try {
    const response = await axios.post("/candidate/extract-details", file, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response.data;
  } catch (error) {
    console.error("Error extracting candidate info from resume:", error);
    return { success: false, message: "Failed to extract candidate info from resume" };
  }
}

export async function getCandidateProfile(id) {
  try {
    const response = await axios.get(`/candidate/${id}/profile-photo`);
    return response.data;
  } catch (error) {
    return { success: false, data: null, message: "Failed to extract candidate profile" };
  }
}

export async function getRecentActivites({ limit, offset }) {
  const response = await axios.get("/candidate/activities", {
    params: {
      limit,
      offset
    }
  });
  return response.data;
}
export async function getProfileStats() {
  const response = await axios.get("/candidate/profile-stats");
  return response.data;
}

export async function getCandidateDashboardStats() {
  const response = await axios.get("/candidate/dashboard/stats");
  return response.data;
}

export async function toggleJobBookmark(jobId) {
  const response = await axios.post("/job-bookmarks/" + jobId);
  return response.data;
}

export async function getBookmarkedJobs({ limit, offset, orderBy, orderByValue, title }) {
  const response = await axios.get("/job-bookmarks", {
    params: {
      limit,
      offset,
      orderBy,
      orderByValue,
      title
    }
  });
  return response.data;
}

export async function getCandidateProfilePhoto(id) {
  const response = await axios.get("/candidate/photo", { params: { id }, responseType: "blob" });
  return response.data;
}

export async function uploadProfilePhoto(id, file) {
  const formData = new FormData();
  formData.append("jp_photo", file);
  const response = await axios.patch(`/candidate/${id}/photo`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  return response.data;
}

export async function deleteProfilePhoto(id) {
  const response = await axios.delete(`/candidate/${id}/photo`);
  return response.data;
}
